var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookWhite35X35 = function SvgFacebookWhite35X35(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54896",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4355",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#1673ea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "facebook-f-3",
    d: "M19.876 12.714h1.347v-2.279a18.709 18.709 0 0 0-1.964-.1 3.073 3.073 0 0 0-3.281 3.368v1.877h-2.2v2.555h2.2v6.53h2.637v-6.53h2.193l.33-2.551h-2.523v-1.631c0-.752.2-1.239 1.261-1.239Z",
    fill: "#fff"
  })));
};
export default SvgFacebookWhite35X35;